import { useEffect, useRef } from "react";
import { Check } from "lucide-react";

const PLANS = [
  {
    name: "Starter Reading",
    price: "$79",
    desc: "A focused single-question tarot session.",
    features: ["45-minute live session", "3-card tarot spread", "Written summary"],
  },
  {
    name: "Complete Chart Journey",
    price: "$249",
    desc: "The full birth chart experience, decoded with you.",
    features: ["90-minute live session", "Full natal chart walkthrough", "Yearly key dates", "Recorded session", "1 follow-up question"],
    featured: true,
  },
  {
    name: "Lifetime Guidance Circle",
    price: "$599",
    desc: "Ongoing readings across a full year of transits.",
    features: ["4 seasonal sessions", "Priority booking", "Unlimited email questions", "Compatibility report included"],
  },
];

export const Pricing = () => {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    if (!window.gsap || !window.ScrollTrigger || !sectionRef.current) return;
    const gsapLib = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsapLib.registerPlugin(ScrollTrigger);

    gsapLib.fromTo(
      cardRefs.current,
      { opacity: 0, y: 55, scale: 0.94 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.75,
        ease: "power3.out",
        stagger: 0.15,
        scrollTrigger: { trigger: sectionRef.current, start: "top 78%" },
      }
    );
  }, []);

  return (
    <section id="pricing" ref={sectionRef} className="cosmic-section max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <p className="reveal cosmic-eyebrow text-sm mb-5">Investment In Your Path</p>
        <h2 className="reveal font-display text-3xl sm:text-4xl lg:text-5xl">Choose Your Reading Plan</h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8 items-start">
        {PLANS.map((p, i) => (
          <div
            key={p.name}
            ref={(el) => (cardRefs.current[i] = el)}
            data-testid={`pricing-card-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
            className={`glass-card p-9 relative ${p.featured ? "md:-translate-y-4 border-[#E8C27A]/60 pricing-pulse" : ""}`}
          >
            {p.featured && (
              <span data-testid="pricing-most-chosen-badge" className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#E8C27A] text-[#1a1127] text-xs font-semibold tracking-[0.1em] uppercase px-4 py-1 rounded-full">
                Most Chosen
              </span>
            )}
            <h3 className="font-display text-xl mb-2 mt-3">{p.name}</h3>
            <p className="text-sm text-[#A99BFF] mb-6 font-light">{p.desc}</p>
            <p className="font-display text-4xl gold-gradient-text mb-7">{p.price}</p>
            <ul className="space-y-3 mb-8">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm text-[#d8d3f0] font-light">
                  <Check size={16} className="text-[#E8C27A] mt-0.5 flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <a
              data-testid={`pricing-select-button-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              href="#"
              className={p.featured ? "btn-gold w-full text-center" : "btn-ghost w-full text-center"}
            >
              <span className="btn-content">Select Plan</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
